<template>
  <div class="widget-form">

    <div class="widget-form-step">
      <div class="widget-form-step__block">
        <div class="widget-form-step__header">
          <div class="widget-form-step__header-title">
            <template v-if="currentStep === 0">{{ $t('form.mobile.who') }}</template>
            <template v-if="currentStep === 1">{{ $t('form.mobile.recipient') }}</template>
            <template v-if="currentStep === 2">{{ $t('form.mobile.sender') }}</template>
            <template v-if="currentStep === 3">{{ $t('form.mobile.when') }}</template>
            <template v-if="currentStep === 4">{{ $t('form.greeting.title_ex') }}</template>
          </div>
          <div class="widget-form-step__header-steps">{{ currentStep + 1 }}/{{ maxSteps() }}</div>
        </div>
        <div class="widget-form-step__content">

          <template v-if="currentStep === 0">
            <div class="widget-form-step__radio-btns">
              <div class="widget-radio-btn" :class="{ 'widget-radio-btn--active': type === 'myself' }">
                <label @click="[resetRecipientPhone(), resetValidation()]" v-if="available.includes('myself')"
                  class="widget-action--send-yourself">
                  <input type="radio" v-model="type" name="recipient_type" value="myself" />
                  <span class="widget-radio-btn__checkmark"><span>
                      <IconCheckEs v-if="type === 'myself'" />
                    </span></span>
                  <span class="widget-radio-btn__content"><span v-html="$t('form.send_to_myself')"></span></span>
                </label>
              </div>
              <div class="widget-radio-btn" :class="{ 'widget-radio-btn--active': type === 'friend' }">
                <label @click="[resetRecipientPhone(), resetValidation()]" v-if="available.includes('friend')"
                  class="widget-action--send-to-friend">
                  <input type="radio" v-model="type" name="recipient_type" value="friend" />
                  <span class="widget-radio-btn__checkmark"><span>
                      <IconCheckEs v-if="type === 'friend'" />
                    </span></span>
                  <span class="widget-radio-btn__content">
                    <span v-if="[18848, 18849].includes(product.id)"
                      v-html="$t('form.send_to_myself_or_friend')"></span>
                    <span v-else v-html="$t('form.send_to_friend')"></span>
                  </span>
                </label>
              </div>
            </div>
          </template>

          <template v-if="type === 'friend'">

            <template v-if="currentStep === 1">

              <template v-if="typeToSend === 'email'">
                <div class="widget-input" v-if="recipientFields.includes('name')">
                  <div class='widget-input__wrapper'>
                    <label>{{ $t('form.recipient.name') }}</label>
                    <input v-model.lazy="recipientName" type="text" name="name" id="widget-input-recipient-name">
                  </div>
                </div>

                <div class="widget-input" :class="{ 'widget-input--error': $v.recipientEmail.$error }">
                  <div class='widget-input__wrapper'>
                    <label>{{ $t('form.recipient.email') }}*</label>
                    <EmailDropdown v-model.lazy="$v.recipientEmail.$model" :key="'recipient-3-email'"
                      @input="delayTouch($v.recipientEmail)" inputId="'recipient-3-email'"
                      :placeholder="$v.recipientEmail.$error ? $t('form.required_field') : ''"
                      :initial-value="getEmail($v.recipientEmail.$model)" :domains="domains" :maxSuggestions="6"
                      :defaultDomains="defaultDomains[$store.state.region.macroregion]" />
                  </div>
                </div>

                <div class="widget-input-checkbox" v-if="recipientFields.includes('phone')">
                  <div class='widget-input-checkbox__wrapper'>
                    <input class="widget-input-checkbox__input"
                      :class="{ 'widget-input-checkbox__input--active': checkedRecipientPhone }"
                      id="checkedPhoneNumberBlockEmail" v-model="checkedRecipientPhone" type="checkbox" />
                    <label for="checkedPhoneNumberBlockEmail">
                      <div class="widget-input-checkbox__icon">
                        <IconCheckboxChecked v-if="checkedRecipientPhone" />
                        <IconCheckbox v-else />
                      </div>
                      <span v-html="$t('form.recipient.checked_phone')"></span>
                    </label>
                  </div>
                </div>

                <div class="widget-input widget-input--phone"
                  :class="{ 'widget-input--error': $v.recipientPhone.$error }"
                  v-if="checkedRecipientPhone && recipientFields.includes('phone')">
                  <div class="widget-input__wrapper">
                    <label>{{ $t('form.recipient.phone') }}*</label>

                    <div class="widget-input__inputs">
                      <v-select class="country-select" :value="selectedCountry" :options="countries"
                        @input="selectCountry" label="country" :clearable="false" :searchable="false">
                        <template #selected-option="{ country }">
                          <RuFlag v-if="country === 'RU'" />
                          <KzFlag v-if="country === 'KZ'" />
                          <ByFlag v-if="country === 'BY'" />
                        </template>
                        <template #option="{ title, country }">
                          <div class="country-select__select-icon">
                            <RuFlag v-if="country === 'RU'" />
                            <KzFlag v-if="country === 'KZ'" />
                            <ByFlag v-if="country === 'BY'" />
                          </div>
                          <div class="country-select__select-text">{{ title }}</div>
                        </template>

                        <template #open-indicator="{ attributes }">
                          <div class="country-select__icon" v-bind="attributes">
                            <IconArrow style="transform: rotate(90deg)" />
                          </div>
                        </template>
                      </v-select>

                      <input-facade :mask="getFormatNumber()" :placeholder="getPlaceholderNumber()"
                        v-model="$v.recipientPhone.$model" @input="delayTouch($v.recipientPhone)"
                        :formatter="formatPhoneNumber" masked prefill type="tel" name="phone" />
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="typeToSend === 'phone' && $store.state.region.macroregion !== 'es'">
                <div class="widget-input" v-if="recipientFields.includes('name')">
                  <div class='widget-input__wrapper'>
                    <label>{{ $t('form.recipient.name') }}</label>
                    <input v-model.lazy="recipientName" type="text" name="name">
                  </div>
                </div>

                <div class="widget-input widget-input--phone"
                  :class="{ 'widget-input--error': $v.recipientPhone.$error }" v-if="recipientFields.includes('phone')">
                  <div class="widget-input__wrapper">
                    <label>{{ $t('form.recipient.phone') }}*</label>

                    <div class="widget-input__inputs">
                      <v-select class="country-select" :value="selectedCountry" :options="countries" label="country"
                        @input="selectCountry" :clearable="false" :searchable="false">
                        <template #selected-option="{ country }">
                          <RuFlag v-if="country === 'RU'" />
                          <KzFlag v-if="country === 'KZ'" />
                          <ByFlag v-if="country === 'BY'" />
                        </template>
                        <template #option="{ title, country }">
                          <div class="country-select__select-icon">
                            <RuFlag v-if="country === 'RU'" />
                            <KzFlag v-if="country === 'KZ'" />
                            <ByFlag v-if="country === 'BY'" />
                          </div>
                          <div class="country-select__select-text">{{ title }}</div>
                        </template>

                        <template #open-indicator="{ attributes }">
                          <div class="country-select__icon" v-bind="attributes">
                            <IconArrow style="transform: rotate(90deg)" />
                          </div>
                        </template>
                      </v-select>

                      <input-facade :mask="getFormatNumber()" :placeholder="getPlaceholderNumber()"
                        v-model="$v.recipientPhone.$model" @input="delayTouch($v.recipientPhone)"
                        :formatter="formatPhoneNumber" masked prefill type="tel" name="phone" />


                    </div>
                  </div>
                </div>
              </template>
            </template>
            <template v-if="currentStep === 2">
              <div class="widget-input">
                <div class='widget-input__wrapper'>
                  <label>{{ $t('form.sender.name') }}</label>
                  <input v-model.lazy="senderName" type="text" name="name" id="widget-input-sender-name">
                </div>
              </div>

              <div class="widget-input" :class="{ 'widget-input--error': $v.senderEmail.$error }">
                <div class='widget-input__wrapper'>
                  <label>{{ $t('form.sender.email') }}*</label>
                  <EmailDropdown v-model.lazy="$v.senderEmail.$model" :key="'sender-2-email'"
                    @input="delayTouch($v.senderEmail)" inputId="'sender-2-email'"
                    :placeholder="$v.senderEmail.$error ? $t('form.required_field') : ''"
                    :initial-value="getEmail($v.senderEmail.$model)" :domains="domains" :maxSuggestions="6"
                    :defaultDomains="defaultDomains[$store.state.region.macroregion]" />
                </div>
              </div>
            </template>


            <template v-if="currentStep === 3">
              <div class="widget-form-step__radio-btns">
                <span style="font-size: 0; display: none">{{ modeTimeSend }}</span>
                <div class="widget-radio-btn" :class="{ 'widget-radio-btn--active': modeTimeSend === 'now' }">
                  <label class="widget-action--send-time-now">
                    <input type="radio" v-model="modeTimeSend" name="send-time_type" value="now" />
                    <span class="widget-radio-btn__checkmark"><span>
                        <IconCheckEs v-if="modeTimeSend === 'now'" />
                      </span></span>
                    <span class="widget-radio-btn__content"><span v-html="$t('form.date.instant')"></span></span>
                  </label>
                </div>
                <div class="widget-radio-btn" :class="{ 'widget-radio-btn--active': modeTimeSend === 'exact' }">
                  <label class="widget-action--send-time-exact">
                    <input type="radio" v-model="modeTimeSend" name="send-time_type" value="exact" />
                    <span class="widget-radio-btn__checkmark"><span>
                        <IconCheckEs v-if="modeTimeSend === 'exact'" />
                      </span></span>
                    <span class="widget-radio-btn__content"><span v-html="$t('form.date.specify')"></span></span>
                  </label>
                </div>
              </div>
            </template>


            <template v-if="currentStep === 4">
              <greeting></greeting>
            </template>
          </template>


          <template v-if="type === 'myself' && currentStep === 1">
            <div class="widget-input" :class="{ 'widget-input--error': $v.recipientEmail.$error }">
              <div class='widget-input__wrapper'>
                <label>{{ $t('form.recipient.your_email') }}*</label>
                <EmailDropdown v-model.lazy="$v.recipientEmail.$model" :key="'recipient-1-email'"
                  @input="delayTouch($v.recipientEmail)" inputId="'recipient-1-email'"
                  :placeholder="$v.recipientEmail.$error ? $t('form.required_field') : ''"
                  :initial-value="getEmail($v.recipientEmail.$model)" :domains="domains" :maxSuggestions="6"
                  :defaultDomains="defaultDomains[$store.state.region.macroregion.region]" />
              </div>
            </div>
          </template>



        </div>

        <template v-if="type === 'friend' && currentStep === 3 && modeTimeSend === 'exact'">
          <div class="widget-form-step-time" v-show="$store.getters['card/current'].type !== 'test'">
            <send-time ref="sendTime"></send-time>
          </div>
        </template>

      </div>

      <template v-if="currentStep === 4">
        <div class="widget-form-step__block">
          <VideoBlock
            :senderEmail="senderEmail"
            :recipientEmail="recipientEmail"
            :recipientPhone="recipientPhone" />
        </div>
      </template>

      <div class="widget-form-step__btns-content">
        <div class="widget-form-step__btns">
          <default-btn :class="{
            'widget-action--mobile-form-back-to-select-phone-or-email': currentStep === 1,
            'widget-action--mobile-form-back-to-recipient': currentStep === 2,
            'widget-action--mobile-form-back-to-sender': currentStep === 3,
            'widget-action--mobile-form-back-to-date': currentStep === 4
          }" class="widget-btn widget-btn--no-icon" grey @click="prevStep()">
            {{ $t('form.buttons.back') }}
          </default-btn>

          <template v-if="type === 'myself'">
            <template v-if="currentStep === 0">
              <default-btn class="widget-btn  widget-btn--no-icon" :class="{
                'widget-action--mobile-form-next-to-send-yourself': currentStep === 0 && type === 'myself',
              }" @click="nextStep()">
                <span>{{ $t('form.buttons.next') }}</span>
              </default-btn>
            </template>
            <template v-if="currentStep === 1 && $store.getters['card/current'].id === null">
              <default-btn class="widget-btn widget-btn--no-icon widget-action--form-pay" @click="payMySelf()">
                <span>{{ $t('form.buttons.to_cart') }}</span>
              </default-btn>
            </template>
          </template>

          <template v-if="type === 'friend'">
            <template v-if="[0, 1, 2, 3].includes(currentStep) || (currentStep === 3 && typeToSend !== 'phone')">
              <default-btn class="widget-btn" :class="{
                'widget-action--mobile-form-next-to-select-phone-or-email': currentStep === 0 && type === 'friend',
                'widget-action--mobile-form-next-to-recipient': currentStep === 1,
                'widget-action--mobile-form-next-to-sender': currentStep === 2,
                'widget-action--mobile-form-next-to-date': currentStep === 3,
                'widget-action--mobile-form-next-to-congratulations': currentStep === 4
              }" @click="nextStep()">
                <span>{{ $t('form.buttons.next') }}</span>
              </default-btn>
            </template>
            <template v-if="$store.getters['card/current'].id === null">
              <template v-if="currentStep === 4 || (typeToSend === 'phone' && currentStep === 3)">
                <default-btn class="widget-btn widget-btn--no-icon widget-action--form-pay" @click="payMySelf()" small>
                  <span>{{ $t('form.buttons.to_cart') }}</span>
                </default-btn>
              </template>
            </template>
          </template>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import VideoBlock from './VideoBlock.vue'
import Greeting from './Greeting'
import { requiredIf } from 'vuelidate/lib/validators'
import { validateEmail } from 'app/modules/utils'
import EmailDropdown from './default/EmailDropdown'
import { domains, defaultDomains } from 'app/modules/constants'
import DefaultBtn from '../components/default/DefaultBtn'
import IconArrow from './icons/IconArrow'
import IconCheckEs from './icons/IconCheckEs'
import SendTime from '../components/SendTime'
import IconCheckbox from './icons/IconCheckbox'
import IconCheckboxChecked from './icons/IconCheckboxChecked'
import parsePhoneNumber from 'libphonenumber-js'
import parseMobilePhoneNumber from 'libphonenumber-js/mobile'

import RuFlag from './icons/countries/ru'
import KzFlag from './icons/countries/kz'
import ByFlag from './icons/countries/by'

const defaultRecipients = ['friend', 'myself']
const defaultWhereToSend = ['email', 'phone']
const touchMap = new WeakMap()
const countries = [
  { title: 'Russia (Россия)', country: 'RU', icon: 'ru.svg', format: '+7 (###) ###-##-##', placeholder: '+7' },
  { title: 'Kazakhstan (Казахстан)', country: 'KZ', icon: 'kz.svg', format: '+7 (###) ###-##-##', placeholder: '+7' },
  /*{ title: 'Belarus (Беларусь)', country: 'BY', icon: 'by.svg', format: '+375 ## ###-##-##', placeholder: '+375' }*/
]
const defaultCountry = countries.find(item => item.country === 'RU')

export default {
  components: {
    VideoBlock,
    IconCheckboxChecked,
    IconCheckbox,
    IconCheckEs,
    greeting: Greeting,
    'send-time': SendTime,
    EmailDropdown,
    DefaultBtn,
    IconArrow,
    RuFlag,
    KzFlag,
    ByFlag,
  },
  data() {
    return {
      domains,
      defaultDomains,
      selectedCountry: defaultCountry,
      countries: countries
    }
  },
  validations: {
    recipientEmail: {
      required: requiredIf(function () {
        return this.typeToSend === 'email' && !this.recipientEmail
      }),
      validateEmail: function (value) {
        if (this.typeToSend === 'email') {
          return validateEmail(value)
        } else {
          return !value
        }
      },
    },
    senderEmail: {
      required: requiredIf(function () {
        return this.type !== 'myself' && this.type !== 'test'
      }),
      validateEmail: function (value) {
        return this.type === 'myself' || this.type === 'test'
          ? true
          : validateEmail(value)
      },
    },
    recipientPhone: {
      required: requiredIf(function () {
        return (this.typeToSend === 'phone' || this.checkedRecipientPhone) && !this.recipientPhone
      }),
      validatePhone: function (value) {
        if (this.typeToSend === 'phone' || this.checkedRecipientPhone) {
          if (!value) {
            return false
          }

          const phoneNumber = parsePhoneNumber(value, this.selectedCountry.country)
          const mobilePhoneNumber = parseMobilePhoneNumber(value, this.selectedCountry.country)

          if (!phoneNumber || !mobilePhoneNumber) {
            return false
          }

          return value && phoneNumber.isValid() && mobilePhoneNumber.isValid()
        } else {
          return true
        }
      },
    },
  },
  computed: {
    currentStep: {
      set(step) {
        this.$store.commit('main/setCurrentFormStepMobile', step)
      },
      get() {
        return this.$store.state.main.currentFormStepMobile
      }
    },
    modeTimeSend: {
      set(mode) {
        this.$store.commit('card/setSendExactTime', mode === 'exact')
      },
      get() {
        return this.$store.state.card.current.sendExactTime ? 'exact' : 'now'
      }
    },
    available() {
      if (typeof this.$store.state.main.options.recipients === 'object') {
        return this.$store.state.main.options.recipients.filter((item) =>
          defaultRecipients.includes(item)
        )
      } else {
        return defaultRecipients
      }
    },
    availableToSend() {
      if (typeof this.$store.state.main.options.recipients === 'object') {
        return this.$store.state.main.options.recipients.filter((item) =>
          defaultWhereToSend.includes(item)
        )
      } else {
        return defaultWhereToSend
      }
    },
    type: {
      set(type) {
        this.$store.commit('card/setType', type)
      },
      get() {
        return this.$store.state.card.current.type
      },
    },
    typeToSend: {
      set(type) {
        if (type === 'email') {
          this.recipientPhone = ''
        }

        this.$store.commit('card/setTypeToSend', type)
      },
      get() {
        return this.$store.state.card.current.typeToSend
      },
    },
    recipientFields() {
      if (this.$store.state.main.recipientFields) {
        return this.$store.state.main.recipientFields
      } if (this.$store.state.region.macroregion === 'es') {
        return ['name', 'email']
      } else {
        return ['name', 'email', 'phone']
      }
    },
    senderEmail: {
      set(senderEmail) {
        this.$store.commit('card/setSenderEmail', senderEmail)
      },
      get() {
        return this.$store.state.card.current.senderEmail
      },
    },
    senderPhone: {
      set(senderPhone) {
        this.$store.commit('card/setSenderPhone', senderPhone)
      },
      get() {
        return this.$store.state.card.current.senderPhone
      },
    },
    senderName: {
      set(senderName) {
        this.$store.commit('card/setSenderName', senderName)
      },
      get() {
        return this.$store.state.card.current.senderName
      },
    },
    recipientEmail: {
      set(recipientEmail) {
        this.$store.commit('card/setRecipientEmail', recipientEmail)
      },
      get() {
        return this.$store.state.card.current.recipientEmail
      },
    },
    recipientPhone: {
      set(recipientPhone) {
        if (recipientPhone) {
          const phoneNumber = parsePhoneNumber(recipientPhone, this.selectedCountry.country)

          if (phoneNumber && phoneNumber.country && phoneNumber.number) {
            this.selectedCountry = countries.find(country => country.country === phoneNumber.country)
            this.$store.commit('card/setRecipientCountryCode', phoneNumber.country)
            this.$store.commit('card/setRecipientNumberPhone', phoneNumber.number)
          }
        }

        this.$store.commit('card/setRecipientPhone', recipientPhone)
      },
      get() {
        return this.$store.state.card.current.recipientPhone
      },
    },
    recipientPhoneValid() {
      return this.$store.state.card.current.recipientNumberPhoneValid
    },
    checkedRecipientPhone: {
      set(checkedRecipientPhone) {
        this.$store.commit('card/setCheckedRecipientPhone', checkedRecipientPhone)

        if (!checkedRecipientPhone) {
          this.$store.commit('card/setRecipientPhone', '')
        }
      },
      get() {
        return this.$store.state.card.current.checkedRecipientPhone
      },
    },
    recipientName: {
      set(recipientName) {
        this.$store.commit('card/setRecipientName', recipientName)
      },
      get() {
        return this.$store.state.card.current.recipientName
      },
    },
    product() {
      return this.$store.state.main.product
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.product.region.toUpperCase() === 'BY') {
        const hasCountryBy = countries.some(country => country.country === 'BY')

        if (!hasCountryBy) {
          countries.push({
            title: 'Belarus (Беларусь)',
            country: 'BY',
            icon: 'by.svg',
            format: '+375 ## ###-##-##',
            placeholder: '+375'
          })
        }
      }

      this.selectedCountry = countries.find(country => country.country === this.product.region.toUpperCase())

      if (this.availableToSend.length === 1 && this.availableToSend[0] === 'phone') {
        this.typeToSend = 'phone'
      }
      if (this.available.length === 1 && this.available[0] === 'friend') {
        this.type = 'friend'
      }
    })
  },
  destroyed() {
    this.$store.commit('main/setCurrentFormStepMobile', 0)
  },
  methods: {
    maxSteps() {
      if (this.typeToSend === 'phone') {
        return '5'
      }

      return this.type === 'friend' ? 5 : 2
    },
    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep -= 1
      } else if (this.currentStep === 0) {
        this.$emit('fire-prev-step')
      }
    },
    nextStep() {
      switch (this.currentStep) {
        case 1: {
          if (!this.$v.recipientEmail.$invalid) {
            this.goNextStep()
          } else {
            this.$v.recipientEmail.$touch()
          }

          break
        }

        /* case 1: {
          if (this.checkedRecipientPhone && this.typeToSend === 'email') {
            if (!this.$v.recipientEmail.$invalid && !this.$v.recipientPhone.$invalid) {
              this.goNextStep()
            } else {
              this.$v.recipientEmail.$touch()
              this.$v.recipientPhone.$touch()
            }
          } else if (this.typeToSend === 'phone') {
            if (!this.$v.recipientPhone.$invalid) {
              this.goNextStep()
            } else {
              this.$v.recipientPhone.$touch()
            }
          } else {
            if (!this.$v.recipientEmail.$invalid) {
              this.goNextStep()
            } else {
              this.$v.recipientEmail.$touch()
            }
          }

          break
        } */

        case 2: {
          if (!this.$v.senderEmail.$invalid) {
            this.goNextStep()
          } else {
            this.$v.senderEmail.$touch()
          }

          break
        }

        case 3: {
          if (this.modeTimeSend === 'exact') {
            if (!this.$refs.sendTime.$v.$invalid) {
              this.goNextStep()
            } else {
              this.$refs.sendTime.$v.$touch()
            }
          } else {
            this.goNextStep()
          }

          break
        }

        default: {
          this.goNextStep()

          break
        }
      }
      console.log(this.currentStep)
    },
    goNextStep() {
      if (this.currentStep < this.maxSteps()) {
        this.currentStep += 1
      }
    },
    delayTouch($v) {
      $v.$reset()

      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v))
      }

      touchMap.set($v, setTimeout($v.$touch, 1500))
    },
    delayTouchPhone($v) {
      $v.$reset()

      if (this.isEnableRecipientPhoneValid) {
        if (touchMap.has($v)) {
          clearTimeout(touchMap.get($v))
        }
        touchMap.set($v, setTimeout($v.$touch, 1500))
      }
    },
    selectCountry(country) {
      this.selectedCountry = country

      this.$store.commit('card/setRecipientPhone', '')
    },
    resetValidation() {
      this.$parent.$refs.recipient.$v.$reset()

      if (this.$refs.sendTime) {
        this.$refs.sendTime.$v.$reset()
      }

      this.$nextTick()
    },
    resetRecipientEmail() {
      this.recipientEmail = ''
    },
    resetRecipientPhone() {
      if (this.typeToSend === 'phone' || this.checkedRecipientPhone) {
        this.recipientPhone = ''
        this.checkedRecipientPhone = false
      }
    },
    getEmail(email) {
      return email && typeof email === 'string' ? email : ''
    },
    payMySelf() {
      this.$emit('pay-my-self')
    },
    getFormatNumber() {
      const currentCountry = this.countries.find(country => country.country === this.selectedCountry.country)

      return currentCountry.format
    },
    getPlaceholderNumber() {
      const currentCountry = this.countries.find(country => country.country === this.selectedCountry.country)

      return currentCountry.placeholder
    },
    formatPhoneNumber(value) {
      let splitStr = value.masked.split('')

      if (this.selectedCountry.country !== 'BY') {
        if (splitStr.length > 3 && splitStr[4] === '9') {
          this.selectedCountry = countries.find(item => item.country === 'RU')
        }

        if (splitStr.length > 3 && splitStr[4] === '7') {
          this.selectedCountry = countries.find(item => item.country === 'KZ')
        }

        /*if (event.inputType === 'insertFromPaste') {
          if (splitStr[4] === '8') {
            splitStr[4] = ''
          }

          splitStr[1] = '7'
        } else if (event.inputType !== 'deleteContentBackward') {
          if (this.selectedCountry.country === 'RU' && splitStr[4] !== '9') {
            splitStr[4] = '9'
          } else if (this.selectedCountry.country === 'KZ' && splitStr[4] !== '7') {
            splitStr[4] = '7'
          }

          splitStr[1] = '7'
        }*/
      }

      return splitStr.join('')
    },
  },
}
</script>

<style lang="scss" scoped>
.widget-form {
  height: 100%;
  flex-grow: 1;
}

.widget-form-step {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &__left,
  &__right {
    display: flex;
    flex-direction: column;
  }

  &__header {
    background-color: #E9EBEC;
    font-weight: 600;
    font-size: rem(15);
    line-height: 120%;
    color: #0B132A;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: rem(20) rem(20) 0 0;
    padding: rem(14) rem(10);

    &--only-title {
      background-color: #E9EBEC;
      color: #0B132A;
      border: rem(1) solid #F1F2F3;
      justify-content: flex-start;
    }
  }

  &__content {
    background-color: #ffffff;
    font-size: rem(15);
    line-height: 140%;
    color: #0B132A;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 0;
    padding: rem(43) rem(10) 0 rem(13);

    &-text {
      font-size: rem(15);
      line-height: 140%;
      color: #0B132A;
      position: relative;
      padding: rem(3) 0;

      &::after {
        height: rem(1);
        background-color: #6E7882;
        content: '';
        opacity: 0.2;
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
      }
    }

    .widget-input {
      margin-bottom: rem(20);

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;


    &-content {
      background-color: #ffffff;
      padding: rem(40) rem(10) rem(10) rem(13);
      border-radius: 0 0 rem(20) rem(20);
    }

    .btn {
      margin-left: rem(10);
    }
  }

  &__text {
    font-size: rem(15);
    line-height: 140%;
    color: #6E7882;
    padding-right: rem(10);

    &--separator {
      border-top: rem(1) solid rgb(110 120 130 / 20%);
      padding-top: rem(10);
    }
  }
}

.widget-form-step-time {
  background-color: #ffffff;
  font-size: rem(15);
  line-height: 140%;
  color: #0B132A;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: rem(30) rem(10) 0 rem(13);
}

.widget-radio-btn {
  margin-bottom: rem(13);

  &:last-child {
    margin-bottom: 0;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ .widget-radio-btn__checkmark > span {
      background: var(--theme-primary-background-component);
    }

    &:checked ~ .widget-radio-btn__content {
      color: #0B132A;
    }
  }

  label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
  }

  &__checkmark {
    width: rem(18);
    height: rem(18);
    font-size: 0;
    line-height: 0;
    flex-shrink: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: rem(1) solid #E9EBEC;
    border-radius: 50%;
    cursor: pointer;

    &>span {
      width: rem(18);
      height: rem(18);
      background-color: #E9EBEC;
      display: inline-flex;
      flex-shrink: 0;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      padding-top: rem(2);
    }
  }

  &__content {
    color: #6E7882;
    margin-left: rem(16);
  }

  &--active {
    .widget-radio-btn__checkmark > span {
      background: var(--theme-primary-background-component);
    }
  }
}

.widget-input-checkbox {
  margin-top: rem(-6);
  margin-bottom: rem(14);
  cursor: pointer;

  &__wrapper {
    display: flex;
    align-items: center;
  }

  input {
    height: 0;
    width: 0;
    font-size: 0;
    border: none;
    outline: none;
    position: relative;
    padding: 0;
    margin: 0;
    opacity: 0;
    z-index: -1;
  }

  label {
    font-size: rem(12);
    line-height: 140%;
    color: #6E7882;
    position: relative;
    padding-top: rem(1);
    padding-left: rem(28);
    transition: 0.3s;
    cursor: pointer;
  }

  &__icon {
    width: rem(15);
    height: rem(15);
    position: absolute;
    top: 0;
    left: 0;
    transition: 0.1s;
  }
}


.widget-input::v-deep {
  label {
    margin-bottom: 0;
  }

  input {
    width: 100%;
    height: rem(36);
    font-size: rem(15);
    line-height: 140%;
    color: #0B132A;
    border: none;
    outline: none;
    padding: 0 rem(26) 0 0;
    border-bottom: rem(1) solid rgb(110 120 130 / 20%);
  }

  .email-dropdown-item:focus-visible {
    outline: none;
  }

  .email-dropdown-wrapper .email-dropdown-list .email-dropdown-item {
    padding: rem(4) rem(8);
    font-size: rem(13);
    border: none;

    &:focus,
    &:hover {
      border: none;
    }
  }

  &.widget-input--error {
    input {
      border-bottom-color: #FA6400;
    }

    .vti__dropdown {
      border-bottom-color: #FA6400;
    }
  }
}


.widget-input {
  &--phone {
    height: rem(36);

    .widget-input__inputs {
      max-height: rem(36);
      display: flex;
    }

    input {
      &::placeholder {
        color: #0B132A;
      }
    }

    &.widget-input--error {
      .country-select {
        border-bottom-color: #FA6400;
      }
    }
  }
}

.country-select {
  cursor: pointer;

  &__icon {
    width: rem(30);
    height: rem(6);
    display: flex;
    align-items: center;
    justify-content: center;
    content: '';
    position: relative;
    cursor: pointer;
    user-select: none;
    transition: 0.2s;
  }

  &__select {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &-icon {
      width: rem(23);
      height: rem(15);
    }

    &-text {
      padding-top: rem(2);
      margin-left: rem(13);
    }
  }

  &::v-deep {
    svg {
      opacity: 0.6;
    }

    &:hover {
      svg {
        opacity: 1;
      }
    }

    .country-select__select-icon {
      svg {
        width: rem(23);
        height: rem(15);
        opacity: 1;
      }
    }
  }
}

.country-select::v-deep {
  max-width: rem(53);
  border-bottom: rem(1) solid rgb(110 120 130 / 20%);

  &.vs--open {
    width: 100%;

    .country-select__icon {
      transition: 0.2s;
      transform: rotate(180deg);
    }
  }

  .vs__dropdown-toggle {
    width: rem(53);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: static;
    border-radius: 0;
    padding: 0 rem(3) 0 0;
    transition: background-color .2s;

    @include mobile {
      background-color: #ffffff;
      padding-left: 0;
    }
  }

  .vs__selected {
    width: rem(20);
    height: rem(15);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: rem(4);

    svg {
      width: rem(20);
      height: rem(15);
      opacity: 1;
      border-radius: rem(4);
    }
  }

  .vs__selected-options {
    font-weight: 600;
    font-size: rem(15);
    line-height: rem(19);
    color: #FFFFFF;
    display: flex;
    align-items: center;
    border-radius: rem(4);
    box-shadow: 0 0 rem(1) rem(1) #E9EBEC;
  }

  input {
    height: 0;
    width: 0;
    font-size: 0;
    border: none;
    outline: none;
    position: relative;
    padding: 0;
    margin: 0;
    opacity: 0;
    z-index: -1;
    background-color: transparent;
  }

  .vs__dropdown-menu {
    width: rem(300);
    background-color: #ffffff;
    overflow-y: scroll;
    position: relative;
    z-index: 4;
    border-radius: rem(3);
    border: rem(1) solid #F1F2F3;
    box-shadow: 0 rem(6) rem(16) rgba(110, 120, 130, 0.12);
    padding: rem(5) 0;
    margin: rem(10) 0 0;

    @include mobile {
      width: rem(250);
      left: rem(-15);
    }
  }

  .vs__dropdown-option {
    height: rem(36);
    background-color: #ffffff;
    font-size: rem(15);
    line-height: 1;
    color: #0B132A;
    list-style: none;
    white-space: nowrap;
    display: flex;
    align-items: center;
    padding-top: rem(2);
    padding-left: rem(13);
    padding-right: rem(5);

    &:hover {
      background-color: #F3F5F6;
      font-weight: 600;
      color: #0B132A;
    }
  }

  * {
    &::-webkit-scrollbar {
      width: rem(6);
      height: rem(5);
      appearance: none;
    }

    &::-webkit-scrollbar-track {
      background-color: #F9FAFB;
      border-radius: rem(3);
      border: 1px solid #F9FAFB;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--theme-primary-background-component);
      border-radius: 3px;
      box-shadow: none;
    }
  }
}
</style>
